import { SET_CUSTOMERS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_CUSTOMERS:
      return action.payload;
    default:
      return state;
  }
};
